import { render, staticRenderFns } from "./specifyDetail.vue?vue&type=template&id=062a41df&"
import script from "./specifyDetail.vue?vue&type=script&lang=js&"
export * from "./specifyDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports